import { render, staticRenderFns } from "./orderSourceSet.vue?vue&type=template&id=198dcf56&"
import script from "./orderSourceSet.vue?vue&type=script&lang=js&"
export * from "./orderSourceSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports